import { AsyncStateNotification } from '@ui/notifications';
import { Button } from 'antd';
import { coreActions } from '@sonar-software/sonar-core';
import { createAsyncSelectors } from '@lib/selectors';
import React from 'react';
import { stringifyObjectFilter } from './@arch/lib';
import { useAction } from '@hooks';
import { COPY_GENERIC, COPY_SPECIFIC } from '@sonar-software/sonar-ts-constants';
export const exportStartSelectors = createAsyncSelectors((state) => state.core.timeline.export.post);
export const DetailsExportButton = ({ disabled, queryParams }) => {
    const startExport = useAction(coreActions.requestPostCoreTimelineExport);
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { disabled: disabled, id: 'timeline-details-export-button', onClick: () => {
                var _a;
                return startExport(Object.assign(Object.assign({}, queryParams), { objectFilter: stringifyObjectFilter((_a = queryParams.objectFilter) !== null && _a !== void 0 ? _a : {}) }));
            }, type: 'default' }, COPY_SPECIFIC.EXPORT),
        React.createElement(AsyncStateNotification, { errored: COPY_GENERIC.CONTACT_SUPPORT, failed: {
                description: COPY_GENERIC.TOO_MANY_EXPORTS,
                options: { message: COPY_GENERIC.COULD_NOT_START_EXPORT }
            }, received: {
                description: COPY_GENERIC.WHEN_EXPORT_COMPLETES,
                options: { message: COPY_GENERIC.EXPORT_STARTED }
            }, resetRawAction: coreActions.resetPostCoreTimelineExport, stateSelector: exportStartSelectors.state })));
};
